import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-search-bar-autocomplete',
  templateUrl: './search-bar-autocomplete.component.html',
  styleUrls: ['./search-bar-autocomplete.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarAutocompleteComponent {
  @Input() width?: number = 300;
  @Input() placeholder?: string = 'Search';
  @Input() value?: string | { label: string; value: string } = '';
  @Input() minLength: number = 4;
  @Input() searchByList: { label: string; value: string }[] = [];
  @Input() searchBy: string;
  @Input() options: { label: string; value: string }[];

  @Output() onSearchChanges = new EventEmitter<{
    emitValue: Boolean;
    value: string;
  }>();
  @Output() onSearchByChanges = new EventEmitter<string>();

  ngOnInit(): void {}

  compareFn = (
    o1: { label: string; value: string } | string,
    o2: { label: string; value: string }
  ) => {
    if (o1) {
      if (o1 === o2.label && this.value !== o1 && !this.value['label']) {
        this.onSearchChanges.emit({ emitValue: true, value: o2.value });
      }
    } else {
      return false;
    }
  };

  onChange(e) {
    if (e.length >= this.minLength || !e.length) {
      this.onSearchChanges.emit({
        emitValue: e.value ? true : false,
        value: e.value ? e.value : e,
      });
    }
  }

  onSearchByChange(e: string) {
    this.value = '';
    this.onSearchByChanges.emit(e);
  }

  onClearValue() {
    this.value = '';
    this.onSearchChanges.emit({ emitValue: false, value: this.value });
  }
}
